import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import StepRoutes from "../../../Routes/steps_routes";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcKindle } from "react-icons/fc";
import { useSelector } from "react-redux";

const ViewSiSchedules = () => {
  const [data, setData] = useState(null);
  let userData = useSelector((store) => store.login.user);
  let { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      `/bookSiteInspection/getConfirmedScheduledByOrderId/${id}`
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setIsCompleted(res.data?.[0]?.siteInspectionStatus || false);
          if (res.data?.length === 1 && userData?.Role !== "saleStaff") {
            setIsConfirmed(true);
          } else if (res.data.length === 1 && userData?.Role === "saleStaff") {
            setIsConfirmed(true);
          }
        } else {
          Toast("error", "Error while getting details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handleCancelSchedule = () => {
    if (id) {
      setLoading(true);
      performRequest("POST", `/bookSiteInspection/cancelSISchedules/${id}`)
        .then((res) => {
          if (res.status === 200) {
            Toast("success", "Schedule Cancel Successfully");
            navigate("/si-schedules");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  };

  const updateViewed = (checked) => {
    setIsCompleted(checked); // instant UI update
    performRequest(
      "PATCH",
      "/bookSiteInspection/updatesikitInspectionStatus/",
      {
        orderId: id,
        isCompleted: checked,
      }
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Site Inspection status updated");
        } else {
          Toast("error", "Failed to update Site Inspection status");
        }
      })
      .catch((err) => CustomErrorResponse(err));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcKindle></FcKindle> View SI Schedules
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header d-flex justify-content-between">
              <div>
                <h2 className="page-title">View SI Schedules</h2>
              </div>
              <div className="d-flex justify-content-between">
                <div className="me-2 d-flex justify-content-between">
                  <label htmlFor="" className="me-2">
                    Completed Site Inspection
                  </label>
                  <input
                    type="checkbox"
                    id="viewed-checkbox"
                    checked={isCompleted}
                    onChange={(e) => updateViewed(e.target.checked)}
                  />
                </div>
              </div>
            </div>

            <div className="card-body">
              {data && (
                <>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Name</label>
                    <div className="w-100 col">
                      {(Array.isArray(data)
                        ? data[0]?.fullName
                        : data?.fullName || "N/A"
                      ).toUpperCase()}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Email</label>
                    <div className="w-100 col">
                      {(Array.isArray(data)
                        ? data[0]?.email
                        : data?.email || "N/A"
                      ).toUpperCase()}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Contact Number
                    </label>
                    <div className="w-100 col">
                      {(Array.isArray(data)
                        ? data[0]?.contactNumber
                        : data?.contactNumber || "N/A"
                      ).toUpperCase()}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Order ID</label>
                    <div className="w-100 col">
                      {Array.isArray(data)
                        ? data[0]?.orderId
                        : data?.orderId || "N/A"}
                    </div>
                  </div>

                  <div className="w-100 col">
                    <div className="mb-3 row">
                      <label className="form-label col-lg-3">
                        {data?.[0]?.finalDate
                          ? "Finalized Schedule"
                          : "Preffered Schedule"}
                      </label>

                      {data?.map((item, index) => (
                        <div key={index} className="col-lg-3">
                          <div className={`card my-1 `}>
                            <div className="card-body">
                              <p className="card-text">
                                {`Date: ${
                                  item?.finalDate
                                    ? item?.finalDate
                                    : item?.prefferedDate
                                }`}
                                <br />
                                {`Time: ${item?.timeSlot}`}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="card-footer">
              <div className="btn-list justify-content-end">
                {!isCompleted && (
                  <SimpleButton
                    buttonText="Cancel Schedule"
                    data-bs-toggle="modal"
                    data-bs-target="#modal-danger"
                  />
                )}

                {(userData?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                  userData?.Role === process.env.REACT_APP_ROLE_ADMIN ||
                  userData?.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN) &&
                  isConfirmed &&
                  !isCompleted && (
                    <SimpleButton
                      buttonText="Edit Confirm Schedule"
                      onClick={() => navigate(`/edit-si-schedules/${id}`)}
                    />
                  )}

                {(userData?.Role === process.env.REACT_APP_ROLE_SALLE ||
                  userData?.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                  userData?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                  userData?.Role === process.env.REACT_APP_ROLE_ADMIN) &&
                  !isConfirmed && (
                    <>
                      <SimpleButton
                        buttonText="Edit Preffered Schedule"
                        onClick={() =>
                          navigate(
                            `/edit-schedule-site-inspection-by-sales/${id}`
                          )
                        }
                      />
                    </>
                  )}

                {(userData?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                  userData?.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                  userData?.Role === process.env.REACT_APP_ROLE_ADMIN) &&
                  !isConfirmed && (
                    <>
                      <SimpleButton
                        buttonText="Confirm SI Schedule"
                        onClick={() =>
                          navigate(`/create-si-schedules/new/${id}`)
                        }
                      />
                    </>
                  )}
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      {/* Modal */}

      <div
        className="modal modal-blur fade"
        id="modal-danger"
        tabIndex="-1"
        style={{ display: "none" }}
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <div className="modal-status bg-danger"></div>
            <div className="modal-body text-center py-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                className="icon mb-2 text-danger icon-lg"
              >
                <path d="M12 9v4"></path>
                <path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z"></path>
                <path d="M12 16h.01"></path>
              </svg>
              <h3>Are you sure?</h3>
              <div className="text-secondary">
                Do you really want to remove schedule? What you've done cannot
                be undone.
              </div>
            </div>
            <div className="modal-footer">
              <div className="w-100">
                <div className="row">
                  <div className="col">
                    <button
                      href="#"
                      className="btn btn-3 w-100"
                      data-bs-dismiss="modal"
                    >
                      {" "}
                      Cancel{" "}
                    </button>
                  </div>
                  <div className="col">
                    <button
                      onClick={handleCancelSchedule}
                      className="btn btn-danger btn-4 w-100"
                      data-bs-dismiss="modal"
                    >
                      {" "}
                      Delete Schedules{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSiSchedules;
